import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";

// Handles the return from Google sign-in: {origin}/account#session_id=...
export function AuthCallback() {
  const { loginWithGoogleSession } = useAuth();
  const location = useLocation();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    const dest = location.pathname && location.pathname !== "/login" ? location.pathname : "/account";
    (async () => {
      try {
        if (!sessionId) throw new Error("Missing session");
        await loginWithGoogleSession(sessionId);
        toast.success("Welcome.");
        nav(dest, { replace: true });
      } catch (err) {
        toast.error(apiError(err));
        nav("/login", { replace: true });
      }
    })();
  }, []); // eslint-disable-line

  return (
    <div data-testid="auth-callback" className="min-h-screen flex items-center justify-center bg-bg">
      <span className="text-[11px] uppercase tracking-ultra text-ink-soft animate-pulse">Signing you in…</span>
    </div>
  );
}
